import React from "react";
import Layout from "../../components/Layout";
import RTF from "../../components/RTF";
import * as S from "./styles";

const Galleries = ({ items }) => {
  return (
    <Layout>
      <div>
        <S.Title>Galleries</S.Title>
        <S.GalleriesList>
          {items.map((o, i) => {
            return (
              <li key={i}>
                <div>{o.title}</div>
                {o.info && <div dangerouslySetInnerHTML={{ __html: o.info }} />}
              </li>
            );
          })}
        </S.GalleriesList>
      </div>
    </Layout>
  );
};

export default Galleries;
